import fetchAPI from '../utils/fetchApi';
import { TFavoriteAd } from 'types/TFavoriteAds';

export default async function getFavorites(l1CategoryId?: string): Promise<TFavoriteAd[]> {
  try {
    const url = l1CategoryId ? `/cp/api/favorites?l1CategoryId=${l1CategoryId}` : `/cp/api/favorites`;
    return await fetchAPI({ url, method: 'GET' });
  } catch {
    return [];
  }
}
